/* src/app/components/doc-viewer-new/dialogs/multi-doc-edit/folder-tree-view-new/folder-tree-view-new.component.scss */
[dialog-body] {
  color: var(--text-color);
}
:host-context(.dark-theme) [dialog-body] {
  color: var(--text-color);
}
.example-tree-progress-bar {
  margin-left: 30px;
}
.selected-button {
  color: #fff;
  background-color: #3949AB;
}
.loader {
  animation: fadeInOut 2s infinite;
  color: #243e90;
  margin-left: 30px;
}
:host-context(.dark-theme) .selected-button {
  background-color: #FFC107;
}
:host-context(.dark-theme) .loader {
  color: #FFC107;
}
/*# sourceMappingURL=folder-tree-view-new.component.css.map */
